<app-document-subheader />
<app-custom-actions-flow-user />
<div class="details-content container-fluid h-100">
  <div class="row h-100">
    <div class="col-content d-flex flex-column h-100">
      @if (this.user$ | async; as user) {
        <div class="page-container">
          <div class="card card-light w-100">
            <div class="card-body">
              <div class="container-fluid">
                <div class="row mb-2">
                  <div class="col-12 col-md-9 mr-auto">
                    <div class="form-group">
                      <label class="form-title-label" translate
                        >USER_LBL_NAME</label
                        >
                        <div class="form-title">{{ user.contactName }}</div>
                      </div>
                    </div>
                    <div class="col-auto ms-auto">
                      <div class="avatar-upload">
                        <div
                          class="avatar-preview rounded-circle shadow-sm position-relative"
                          >
                          <div
                            id="imagePreview"
                            class="rounded-circle"
                        [ngStyle]="{
                          'background-image':
                            'url(' + this.apiUrl + user.contactPicturePath + ')'
                        }"
                            >
                            @if (!user.contactPicturePath) {
                              @if (true) {
                                <img
                                  id="pictureContact"
                                  class="picture-control active"
                                  src="../../../../assets/images/user.svg"
                                  />
                              }
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-md">
                      <div class="form-group row">
                        <label class="col-4 col-form-label-sm" translate
                          >USER_LBL_EMAIL</label
                          >
                          <div class="col">
                            <span class="form-control-plaintext form-control-sm">
                              <app-mail-to-link [email]="user.aspNetUserEmail" />
                            </span>
                          </div>
                        </div>
                        <div class="form-group row">
                          <label class="col-4 col-form-label-sm" translate
                            >USER_LBL_TELEPHONY_EXTENSION</label
                            >
                            <div class="col">
                              <span class="form-control-plaintext form-control-sm">
                                {{ user.telephonyExtension }}
                              </span>
                            </div>
                          </div>
                        <!-- <div class="form-group row">
                        <label class="col-4 col-form-label-sm" translate
                          >USER_LBL_ROLES</label
                          >
                          <div class="col">
                            <span
                              class="form-control-plaintext form-control-sm badge-list"
                              >
                              <app-badge-list [InputBadges]="user.rolesLoc" />
                            </span>
                          </div>
                        </div> -->
                        <div class="form-group row">
                          <label class="col-4 col-form-label-sm" translate
                            >USER_LBL_GROUP</label
                            >
                            <div class="col">
                              <span
                                class="form-control-plaintext form-control-sm badge-list"
                                >
                                <!-- <app-badge *ngFor="let role of user.roles" [message]="role" color="primary"></app-badge> -->
                                <app-badge-list
                                  [InputBadges]="user.groups | groupModelName"
                                  />
                                </span>
                              </div>
                            </div>
                          </div>
                          <div class="col">
                            <div class="form-group row">
                              <label class="col-4 col-form-label-sm" translate
                                >USER_LBL_SALES_TEAM_NAME</label
                                >
                                <div class="col">
                                  <span class="form-control-plaintext form-control-sm">
                                    {{
                                    user.userSalesTeams
                                    | salesTeamExtractName
                                    | joinAllArrayValues : ","
                                    }}
                                  </span>
                                </div>
                              </div>
                              <div class="form-group row">
                                <label class="col-4 col-form-label-sm" translate
                                  >USER_LBL_SALES_TEAM_MAIN</label
                                  >
                                  <div class="col">
                                    <span class="form-control-plaintext form-control-sm">
                                      {{ user.mainSalesTeamName }}
                                    </span>
                                  </div>
                                </div>
                                <div class="form-group row">
                                  <label class="col-4 col-form-label-sm" translate
                                    >USER_LBL_COMMISSION_PLAN_NAME_SALESPERSON</label
                                    >
                                    <div class="col">
                                      <span class="form-control-plaintext form-control-sm">
                                        {{ user.salesPersonCommissionPlanName }}
                                      </span>
                                    </div>
                                  </div>
                                  <div class="form-group row">
                                    <label class="col-4 col-form-label-sm" translate
                                      >USER_LBL_COMMISSION_PLAN_NAME_SHARED</label
                                      >
                                      <div class="col">
                                        <span class="form-control-plaintext form-control-sm">
                                          {{ user.sharedCommissionPlanName }}
                                        </span>
                                      </div>
                                    </div>
                                  <div class="form-group row">
                                    <label class="col-4 col-form-label-sm" translate
                                      >USER_LBL_WORK_SCHEDULE</label
                                      >
                                      <div class="col">
                                        <span class="form-control-plaintext form-control-sm">
                                          {{ user.workScheduleName }}
                                        </span>
                                      </div>
                                    </div>
                                    <!--                  <div class="form-group row">-->
                                    <!--                    <label class="col-4 col-form-label-sm" translate>USER_LBL_ACTIVE</label>-->
                                    <!--                    <div class="col">-->
                                    <!--                      <span class="form-control-plaintext form-control-sm">-->
                                    <!--                       <input type="checkbox" name="active" [(ngModel)]="user.aspNetUserEmailConfirmed"-->
                                    <!--                              onclick="return false;" disabled/>-->
                                    <!--                        &lt;!&ndash;   onkeydown="e = e || window.event; if(e.keyCode !== 9) return false;"  &ndash;&gt;-->
                                  <!--                      </span>-->
                                <!--                    </div>-->
                              <!--                  </div>-->
                            </div>
                          </div>
                          <app-user-tabs-details />
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
              @if (this.user$ | async; as user) {
                <div class="col-comment">
                  <app-comment-panel
                    [entityType]="'User'"
                    [entityId]="user.id.toString()"
                  ></app-comment-panel>
                </div>
              }
            </div>
          </div>
